import { render } from "./BookingWizard.vue?vue&type=template&id=653f351e"
import script from "./BookingWizard.vue?vue&type=script&lang=js"
export * from "./BookingWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingWizard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "653f351e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('653f351e', __exports__)) {
    api.reload('653f351e', __exports__)
  }
  
  module.hot.accept("./BookingWizard.vue?vue&type=template&id=653f351e", () => {
    api.rerender('653f351e', render)
  })

}


export default __exports__